/**
 * useOrders — React Query hooks for the signed-in student's orders.
 *
 * Order history is per-account, so every hook here stays disabled until the
 * customer is authenticated; the query key carries the customer id so that
 * signing out and back in as someone else never shows the previous account's
 * orders from cache.
 */

import { useQuery } from '@tanstack/react-query';
import { ordersApi } from '@/api/orders.api';
import { useCustomerAuth } from '@/context/CustomerAuthContext';

export function useMyOrders() {
  const { customer, isAuthenticated } = useCustomerAuth();
  return useQuery({
    queryKey: ['orders', 'mine', customer?._id ?? null],
    queryFn: ordersApi.listMine,
    enabled: isAuthenticated,
  });
}

export default useMyOrders;
